import React, { useEffect, useMemo, useRef, useState } from "react";
import Slider from "react-slick";
import logo1 from "../../../assets/landing-page/testimonial/logo1.jpg";
import image1 from "../../../assets/landing-page/testimonial/image1.jpg";
import logo2 from "../../../assets/landing-page/testimonial/logo2.png";
import image2 from "../../../assets/landing-page/testimonial/image2.jpg";
import logo3 from "../../../assets/landing-page/testimonial/logo3.png";
import image3 from "../../../assets/landing-page/testimonial/image3.jpg";
import logo4 from "../../../assets/landing-page/testimonial/logo4.png";
import image4 from "../../../assets/landing-page/testimonial/image4.jpg";
import logo5 from "../../../assets/landing-page/testimonial/logo5.jpg";
import image5 from "../../../assets/landing-page/testimonial/image5.jpg";
import logo6 from "../../../assets/landing-page/testimonial/logo6.png";
import image6 from "../../../assets/landing-page/testimonial/image6.jpg";
import logo7 from "../../../assets/landing-page/testimonial/logo7.jpg";
import image7 from "../../../assets/landing-page/testimonial/image7.png";
import logo8 from "../../../assets/landing-page/testimonial/logo8.png";
import image8 from "../../../assets/landing-page/testimonial/image8.png";
import logo9 from "../../../assets/landing-page/testimonial/logo9.png";
import image9 from "../../../assets/landing-page/testimonial/image9.png";
import logo10 from "../../../assets/landing-page/testimonial/logo10.jpg";
import image10 from "../../../assets/landing-page/testimonial/image10.jpg";
import logo11 from "../../../assets/landing-page/testimonial/logo11.jpg";
import image11 from "../../../assets/landing-page/testimonial/image11.jpg";
import logo12 from "../../../assets/landing-page/testimonial/logo12.jpg";
import image12 from "../../../assets/landing-page/testimonial/image12.jpg";
import AnimateFromBottom from "../../LandingPage/component/AnimateFromBottom";
import language from "../../../helpers/language";

const chunkArray = (array, size) => {
  if (!Array.isArray(array) || size <= 0) return [];
  const chunks = [];
  for (let i = 0; i < array.length; i += size) chunks.push(array.slice(i, i + size));
  return chunks;
};

const TestimonialCard = ({ testimonial, expanded, onToggle, lang }) => {
  const textRef = useRef(null);
  const [canExpand, setCanExpand] = useState(false);

  useEffect(() => {
    if (expanded) return undefined;

    const measureText = () => {
      if (!textRef.current) return;
      setCanExpand(textRef.current.scrollHeight > textRef.current.clientHeight + 1);
    };

    measureText();
    window.addEventListener("resize", measureText);
    return () => window.removeEventListener("resize", measureText);
  }, [testimonial.text, expanded]);

  return (
    <article
      className="w-full flex-1 border border-gray-200 rounded-xl shadow-sm p-6 flex flex-col"
      style={{ minHeight: "240px", backgroundColor: "#F3F3F3" }}
    >
      <img
        src={testimonial.logo}
        alt={`${testimonial.name} logo`}
        className="h-10 w-10 object-contain rounded mb-4"
      />

      <p
        ref={textRef}
        className="text-sm text-gray-700 leading-relaxed"
        style={
          expanded
            ? undefined
            : {
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: 6,
                WebkitBoxOrient: "vertical",
              }
        }
      >
        {testimonial.text}
      </p>

      {canExpand && (
        <button
          type="button"
          onClick={onToggle}
          className="text-royal text-sm font-semibold mt-2 text-left self-start"
        >
          {expanded ? (lang?.see_less ?? "See less") : (lang?.see_more ?? "See more")}
        </button>
      )}

      <div className="flex items-center gap-3 mt-auto pt-6">
        <img
          src={testimonial.image}
          alt={testimonial.name}
          className="w-10 h-10 rounded-full object-cover flex-shrink-0"
        />
        <div>
          <h3 className="font-bold text-sm text-gray-900 leading-tight">
            {testimonial.name}
          </h3>
          <p className="text-xs text-gray-500 leading-tight mt-0.5">
            {testimonial.position}
          </p>
        </div>
      </div>
    </article>
  );
};

const NewTestimonials = () => {
  const [lang] = useState(language.getLang());
  const sliderRef = useRef(null);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const [expanded, setExpanded] = useState({});

  const testimonials = [
    { id: 1,  logo: logo1,  image: image1,  text: lang.testimonials[0].text,  name: lang.testimonials[0].name,  position: lang.testimonials[0].position  },
    { id: 2,  logo: logo2,  image: image2,  text: lang.testimonials[1].text,  name: lang.testimonials[1].name,  position: lang.testimonials[1].position  },
    { id: 3,  logo: logo3,  image: image3,  text: lang.testimonials[2].text,  name: lang.testimonials[2].name,  position: lang.testimonials[2].position  },
    { id: 4,  logo: logo4,  image: image4,  text: lang.testimonials[3].text,  name: lang.testimonials[3].name,  position: lang.testimonials[3].position  },
    { id: 5,  logo: logo5,  image: image5,  text: lang.testimonials[4].text,  name: lang.testimonials[4].name,  position: lang.testimonials[4].position  },
    { id: 6,  logo: logo6,  image: image6,  text: lang.testimonials[5].text,  name: lang.testimonials[5].name,  position: lang.testimonials[5].position  },
    { id: 7,  logo: logo7,  image: image7,  text: lang.testimonials[6].text,  name: lang.testimonials[6].name,  position: lang.testimonials[6].position  },
    { id: 8,  logo: logo8,  image: image8,  text: lang.testimonials[7].text,  name: lang.testimonials[7].name,  position: lang.testimonials[7].position  },
    { id: 9,  logo: logo9,  image: image9,  text: lang.testimonials[8].text,  name: lang.testimonials[8].name,  position: lang.testimonials[8].position  },
    { id: 10, logo: logo10, image: image10, text: lang.testimonials[9].text,  name: lang.testimonials[9].name,  position: lang.testimonials[9].position  },
    { id: 11, logo: logo11, image: image11, text: lang.testimonials[10].text, name: lang.testimonials[10].name, position: lang.testimonials[10].position },
    { id: 12, logo: logo12, image: image12, text: lang.testimonials[11].text, name: lang.testimonials[11].name, position: lang.testimonials[11].position },
  ];

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
  };

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth || 1200;
      if (w < 520) setItemsPerPage(1);
      else if (w < 1024) setItemsPerPage(2);
      else setItemsPerPage(3);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const pages = useMemo(
    () => chunkArray(testimonials, itemsPerPage),
    [testimonials, itemsPerPage]
  );

  const toggleExpanded = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section className="md:px-14 px-4 md:pt-12 md:pb-12 py-6 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto">

        {/* Heading */}
        <AnimateFromBottom delay={0.2}>
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-extrabold text-black mb-2">
              {lang?.Testimonials_title}
            </h2>
            <p className="text-sm text-gray-500">{lang?.Testimonials_subtitle}</p>
          </div>
        </AnimateFromBottom>

        {/* Slider + Arrows */}
        <AnimateFromBottom delay={0.3}>
          <div className="overflow-hidden">
          <Slider ref={sliderRef} {...settings}>
            {pages.map((group, pageIndex) => (
              <div key={pageIndex}>
                <div className="flex flex-col md:flex-row items-stretch gap-4 px-1 py-2">
                  {group.map((t) => (
                    <TestimonialCard
                      key={t.id}
                      testimonial={t}
                      expanded={Boolean(expanded[t.id])}
                      onToggle={() => toggleExpanded(t.id)}
                      lang={lang}
                    />
                  ))}
                </div>
              </div>
            ))}
          </Slider>
          </div>

          {/* Centered arrows below slider */}
          <div className="flex items-center justify-center gap-3 mt-6">
            <button
              type="button"
              onClick={() => sliderRef.current?.slickPrev()}
              className="w-10 h-10 rounded-md border border-gray-300 bg-white flex items-center justify-center hover:bg-gray-50 transition-colors shadow-sm"
              aria-label="Previous"
            >
              <i className="fa fa-arrow-left text-gray-700 text-sm" />
            </button>
            <button
              type="button"
              onClick={() => sliderRef.current?.slickNext()}
              className="w-10 h-10 rounded-md flex items-center justify-center transition-colors shadow-sm"
              style={{ backgroundColor: "#1a3a5c" }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = "#152e4a"}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = "#1a3a5c"}
              aria-label="Next"
            >
              <i className="fa fa-arrow-right text-white text-sm" />
            </button>
          </div>
        </AnimateFromBottom>

      </div>
    </section>
  );
};

export default NewTestimonials;
